export default __webpack_public_path__ + "static/media/question-bank.b12ad10f.svg";